import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class TemperatureReadings_ds_find_temperature_reading_pointsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { name: string }): 
  Promise<{ result: { Id?: number, IsDefault?: boolean, Name?: string } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.name)) {
      missingRequiredInParams.push('\'name\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/TemperatureReadings/datasources/ds_find_temperature_reading_points/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      name: string    }) {
        if(isNil(inParams.name)) {
          return true; 
        }
      return false;
    }
}
